import React from 'react'
import VolunteerFormPopup from '../volunteerForm/VolunteerFormPopup'
import HalfBanner from '../HomePage/HalfBanner'
import EventBanner from '../Events/EventBanner'
import Footer from '../HomePage/Footer'
import FAQs from '../ContactUs/FAQs'
import DonationCard from './DonationCard'
import DonationQr from './DonationQr.js'
import ContactusBanner from '../ContactUs/ContactusBanner.js'
import StayConnectedSocialIcons from '../Events/StayConnectedSocialIcons.js'
export default function DonationMainPage() {
  const title = "It becomes a legacy of care. Join us in our commitment to human dignity and the well-being of those we serve."

  const subTitle = ''
  return (
    <div>
      <VolunteerFormPopup />
      <ContactusBanner title={title} description={subTitle} />

      <DonationCard />
      <ContactusBanner title={'In the quiet act of giving, we find the profound unity of all life.'} description={subTitle} />
      <DonationQr />
      <FAQs />
      <StayConnectedSocialIcons/>
      <Footer />

    </div>
  )
}
